
<template>
  <div class="auth-layout">
    <router-view />
  </div>
</template>

<style>
.auth-layout {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}
</style>